<template>
  <span>
    <RevButton
      v-if="!isCustomerBlocked"
      size="small"
      variant="secondary"
      @click="$emit('click')"
    >
      {{ i18n(translations.refund) }}
    </RevButton>

    <RevTooltip
      v-if="isCustomerBlocked"
      content-class-names="z-20 max-w-[250px]"
    >
      <template #trigger="{ show, hide }">
        <RevButton
          :disabled="isRefundDisabled"
          size="small"
          variant="secondary"
          @click="$emit('click')"
          @focusin="show"
          @focusout="hide"
          @mouseleave="hide"
          @mouseover="show"
        >
          {{ i18n(translations.refund) }}
        </RevButton>
      </template>
      {{ i18n(translations.refundCustomerBlockedTooltip) }}
    </RevTooltip>
  </span>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevTooltip } from '@ds/components/Tooltip'

import translations from './RefundButton.translations'

defineEmits(['click'])

defineProps<{
  isRefundDisabled: boolean
  isCustomerBlocked: boolean
}>()

const i18n = useI18n()
</script>
